import script from "./ReciptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReciptModal.vue?vue&type=script&setup=true&lang=js"

import "./ReciptModal.vue?vue&type=style&index=0&id=e8a04692&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8a04692"]])

export default __exports__